import styled, {css} from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import {CssRule} from '../../../../themes/architecture/css-helpers/css-rule';

interface IUsefulLinksItemBoxProps {
    hideArrow?: boolean;
    icon?: string,
}

const DefaultBox = styled.li<IUsefulLinksItemBoxProps>`
    position: relative;
    width: 100%;
    /*
        The border-bottom is intentionally set to theme.colors.itemTopBorder and also border-top set to theme.colors.itemBottomBorder
        The reason is that the bottom border of the useful link item is actually the top border of the divider 
        and top border of the useful link item is actually the bottom border of the divider
        
    */
    border-bottom: 1px solid ${props => props.theme.colors.dividerTopBorder};
    border-top: 1px solid ${props => props.theme.colors.dividerBottomBorder};
    padding-left: 1rem;
    white-space: nowrap;
    cursor: pointer;
    background-color: ${props => props.theme.colors.usefulLinkBackground};
      
    &:last-child {
        border-bottom: 0;
    }
    
    &:after {
      content: "";
      position: absolute;
      right: 5px;
      background-image: url("${props => props.theme.images.spriteSheet.toString()}");
      background-repeat: no-repeat; 
      ${CssRule.For.RTL.build()} & {
        transform: scaleX(-1);
      }
    }
    
    &:before {
      display: inline-block;
      margin-right: 5px;
      background-repeat: no-repeat; 
      background-size: cover;
    }
`;


export const PcBox = styled(DefaultBox)`
    height: 3.75rem;
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 3.5rem;
    color: ${props => props.theme.colors.usefulLinkTextNormal};
    
    &:first-child {
        margin-top: 3px;
    }
    
    &:hover {
        color: ${props => props.theme.colors.usefulLinkTextHover};
    }
    
    ${({hideArrow}) => !hideArrow && css`
        &:after {
            top: 1.5rem;
            width: 5px;
            height: 9px;
            background-position: -785px -657px;
        }
    `}
    
    ${({icon}) => icon && css`
          &:before {       
            content: "";
            position:relative;
            top: 3px;       
            width: 21px;
            height: 21px;
            background-image: url("${icon.toString()}");
          }
    `}
`;

export const MobileBox = styled(DefaultBox)`
    display: flex;
    align-items: center;
    height: 5rem;
    font-weight: 300;
    font-size: 1.7rem;
    line-height: 5rem;
    color: ${props => props.theme.colors.usefulLinkTextHover};
    font-family: ${props => props.theme.font.family.regular};
    
    &:first-child {
        margin-top: 5px;
    }
    
    ${({hideArrow}) => !hideArrow && css`
          &:after {
              top: 2rem;
              width: 15px;
              height: 15px;
              background-position: -751px -655px;
          }
    `}
    
    ${({icon}) => icon && css`
          &:before {       
            content: "";
            width: 21px;
            height: 21px;
            background-image: url("${icon.toString()}");
          }
    `}
`;


export const UsefulLinksItemDefaultBox = styledByDevice(PcBox, MobileBox);